export default [
            {
                path: '/finance-dashboard',
                name: 'finance-dashboard',
                component: () => import('./FinanceDashboard.vue'),
            }
]